/* ViskoLove behaviour capture for the panel's Clarity tab (vl-stats.uralmedical.com/stats/clarity), 2026-10-14.
   Runs after vl-track.js and borrows its visitor id, visit id and e-mail. Per page view it records WHERE the visitor
   taps (page coordinates, the tapped element, its text, the position inside it), HOW FAR the page is scrolled, the
   mouse's path on desktops, script errors, when a form field is focused (never what is typed), and the page's own
   signals of trouble: a rage click (the same spot three times within 700 ms), a dead click (a tap after which nothing
   on the page changed for 900 ms), an error click (a script error right after a tap). Everything goes in small batches
   (every 5 s, at 60 events, and when the page goes away) as a text/plain beacon to {api}/c — no preflight, no cookies.
   Switch and knobs: Theme settings → ViskoLove → Visitor tracking (window.vlClarityCfg, layout/theme.liquid).
   Nothing a shopper types is ever read: no input values, no form fields' contents, no text selections. */
(function () {
  var cfg = window.vlClarityCfg || {}; var T = window.vlTrack;
  if (!cfg.api || !T || !T.vid || window.vlNoTrack) return;                            // vlNoTrack: the panel's own screenshot job (mac/shots.mjs)
  var sample = Number(cfg.sample); if (!(sample >= 0 && sample <= 100)) sample = 100;
  if (sample < 100) { /* the same browser is always on the same side of the sample (its id hashed) */
    var h = 2166136261, s = String(T.vid); for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    if (((h >>> 0) % 100) >= sample) return;
  }
  var api = String(cfg.api).replace(/\/$/, '') + '/c';
  var CW = Number(cfg.cw) || 1480;                 // the theme's content width: desktop x is stored relative to it
  var MOVES = cfg.moves !== false, MOVE_MAX = Number(cfg.max) || 600;
  var start = Date.now(), now = function () { return Date.now() - start; };
  var pvid = (start.toString(36) + Math.random().toString(36).slice(2, 12)).replace(/[^a-z0-9]/g, '').slice(0, 24);
  var touch = (window.matchMedia && matchMedia('(pointer: coarse)').matches) || 'ontouchstart' in window;
  var tcfg = window.vlTrackCfg || {};
  var ev = [], opened = false, timer = null, gone = false, maxd = 0, sdist = 0, lastY = window.scrollY || 0, moves = [], moveN = 0, errN = 0, lastClick = null, bursts = [];
  var pageH = function () { var d = document.documentElement, b = document.body; return Math.max(d ? d.scrollHeight : 0, b ? b.scrollHeight : 0, window.innerHeight, 1); };
  var cLeft = function () { return window.innerWidth > CW ? (window.innerWidth - CW) / 2 : 0; };
  var cWidth = function () { return Math.min(window.innerWidth, CW); };
  var r4 = function (x) { return Math.round(x * 10000) / 10000; };
  var depth = function () { var d = (window.scrollY + window.innerHeight) / pageH(); if (d > maxd) maxd = d > 1 ? 1 : d; };

  /*SEL-START*/
  /* a compact, stable address for an element: ids that look hand-written, up to two classes that are not a state, a
     position among same-tag siblings when there is no class; five levels at most. The screenshot job on the Mac
     (slot-worker/mac/shots.mjs) runs THIS SAME TEXT inside the page it photographs, so a tap recorded here finds its
     element in the picture even when the visitor's screen had another width. Keep the markers; never edit one copy. */
  function vlSel(el) {
    var parts = [], n = el, depth = 0;
    while (n && n.nodeType === 1 && n !== document.body && n !== document.documentElement && depth < 5) {
      var tag = n.tagName.toLowerCase();
      var id = n.id && /^[A-Za-z][\w-]{0,40}$/.test(n.id) && !/\d{5,}/.test(n.id) ? n.id : '';
      if (id) { parts.unshift('#' + id); break; }
      var good = [], list = n.classList ? n.classList : [];
      for (var i = 0; i < list.length && good.length < 2; i++) {
        var c = list[i];
        if (/^(is-|has-|js-|hdt-s-|active$|open$|hover$|focus$|loading$|hidden$|show$|visible$|selected$|current$|on$|lazyload)/.test(c) || /\d{3,}/.test(c) || c.length > 40) continue;
        good.push(c);
      }
      var nth = '';
      if (!good.length && n.parentNode && n.parentNode.children && n.parentNode.children.length > 1) {
        var sib = n.parentNode.children, k = 0, idx = 0;
        for (var j = 0; j < sib.length; j++) { if (sib[j].tagName === n.tagName) { k++; if (sib[j] === n) idx = k; } }
        if (k > 1) nth = ':nth-of-type(' + idx + ')';
      }
      parts.unshift(tag + (good.length ? '.' + good.join('.') : '') + nth);
      n = n.parentNode; depth++;
    }
    return parts.join('>').slice(0, 120);
  }
  var VL_ACT = 'a,button,input,select,textarea,label,summary,[role="button"],[role="link"],[role="tab"],[role="menuitem"],[onclick],[tabindex]:not([tabindex="-1"])';
  /* the element a tap means: the closest clickable ancestor, else the tapped element itself (an icon inside a button
     is the button; an svg's path is its svg) */
  function vlTarget(t) {
    if (!t || t.nodeType !== 1) return null;
    var a = t.closest ? t.closest(VL_ACT) : null; if (a) return a;
    var svg = t.closest ? t.closest('svg') : null; if (svg) return svg;
    return t;
  }
  /*SEL-END*/

  var textOf = function (el) {
    var tag = el.tagName.toLowerCase(), t = '';
    if (tag === 'input' || tag === 'textarea' || tag === 'select') t = el.getAttribute('placeholder') || el.getAttribute('aria-label') || el.getAttribute('name') || '';
    else if (tag === 'img') t = el.getAttribute('alt') || '';
    else t = el.getAttribute('aria-label') || el.innerText || el.textContent || '';
    if (!t && el.querySelector) { var im = el.querySelector('img[alt]'); if (im) t = im.getAttribute('alt') || ''; }
    return String(t).replace(/\s+/g, ' ').trim().slice(0, 60);
  };
  var isField = function (el) { return !!(el && el.matches && el.matches('input,textarea,select,label,[contenteditable]')); };

  var push = function (e) { ev.push(e); if (ev.length >= 60) flush(false); };
  var send = function (json, final) {
    try { if (navigator.sendBeacon && navigator.sendBeacon(api, new Blob([json], { type: 'text/plain' }))) return; } catch (e) {}
    try { fetch(api, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: json }).catch(function () {}); } catch (e) {}
  };
  var flush = function (final) {
    if (moves.length) { ev.push({ k: 'm', pts: moves }); moves = []; }
    if (!ev.length && opened) return;
    var body = {
      v: 1, vid: T.vid, sid: T.sid || '', pvid: pvid, email: T.email ? T.email() : '',
      path: location.pathname.slice(0, 200), page: tcfg.page || '', handle: tcfg.handle || '', title: (tcfg.title || document.title || '').slice(0, 120),
      vw: window.innerWidth, vh: window.innerHeight, ph: pageH(), touch: touch ? 1 : 0, cw: CW, t0: start, ev: ev
    };
    if (!opened) {
      var nav = ''; try { var ne = performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; nav = ne ? ne.type : ''; } catch (e) {}
      body.open = { ref: (document.referrer || '').slice(0, 200), nav: nav, sw: window.screen ? screen.width : 0, dpr: window.devicePixelRatio || 1 };
      opened = true;
    }
    ev = [];
    send(JSON.stringify(body), final);
  };
  var schedule = function () { if (timer || gone) return; timer = setTimeout(function () { timer = null; flush(false); }, 5000); };

  /* ---- taps: rage, dead and error verdicts ---- */
  var pending = [];      // clicks waiting for their 900 ms verdict
  var mo = null, moUntil = 0;
  var IGNORE = '.vl-hero,.hdt-marquee,hdt-marquee,marquee';
  var onMut = function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m.type === 'characterData') continue;                                           // a ticking countdown is not an effect
      if (m.type === 'childList') { var only = true, ns = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes)); for (var j = 0; j < ns.length; j++) if (ns[j].nodeType === 1) { only = false; break; } if (only) continue; }
      var t = m.target && m.target.nodeType === 1 ? m.target : (m.target ? m.target.parentNode : null);
      if (t && t.closest && t.closest(IGNORE)) continue;                                  // the hero's own slide change
      for (var p = 0; p < pending.length; p++) pending[p].changed = true;
      return;
    }
  };
  var watch = function () {
    moUntil = now() + 950;
    if (mo) return;
    try { mo = new MutationObserver(onMut); mo.observe(document.documentElement, { childList: true, attributes: true, subtree: true }); } catch (e) { mo = null; }
    setTimeout(function unwatch() { if (now() < moUntil) { setTimeout(unwatch, 200); return; } if (mo) { mo.disconnect(); mo = null; } }, 1000);
  };
  var settle = function (c, why) {
    var i = pending.indexOf(c); if (i < 0) return; pending.splice(i, 1);
    if (why === 'timeout') c.dead = (!c.field && !c.changed && !c.nav) ? 1 : 0; else c.dead = 0;
    delete c.field; delete c.changed; delete c.nav; delete c.el;
    push(c); schedule();
  };
  document.addEventListener('scroll', function () { for (var i = 0; i < pending.length; i++) pending[i].changed = true; }, true);
  window.addEventListener('pagehide', function () { for (var i = pending.length - 1; i >= 0; i--) { pending[i].nav = true; settle(pending[i], 'nav'); } });
  window.addEventListener('hashchange', function () { for (var i = 0; i < pending.length; i++) pending[i].changed = true; });
  document.addEventListener('click', function (e) {
    var el = vlTarget(e.target); if (!el) return;
    if (e.detail === 0 && !e.clientX && !e.clientY) return;                               // Enter on a focused button: no place on the page
    var t = now(), ph = pageH(), x = Math.round(e.pageX), y = Math.round(e.pageY);
    var r = null; try { r = el.getBoundingClientRect(); } catch (err) {}
    var act = !!(el.matches && el.matches(VL_ACT)); if (!act) { try { act = getComputedStyle(el).cursor === 'pointer'; } catch (err) {} }
    var href = ''; if (el.tagName === 'A') { try { var u = new URL(el.href, location.href); href = (u.hostname === location.hostname ? u.pathname + u.search : u.hostname + u.pathname).slice(0, 120); } catch (err) {} }
    var c = { k: 'c', t: t, x: x, y: y, xf: r4((e.pageX - cLeft()) / cWidth()), yf: r4(e.pageY / ph), sel: vlSel(el), tag: el.tagName.toLowerCase(), txt: textOf(el), href: href, act: act ? 1 : 0,
      ex: r && r.width ? r4((e.clientX - r.left) / r.width) : 0.5, ey: r && r.height ? r4((e.clientY - r.top) / r.height) : 0.5, rage: 0, rb: 0, dead: 0, err: 0, field: isField(el), changed: false, nav: false };
    /* rage: this tap and at least two earlier ones within 700 ms, all within 30 px of each other */
    bursts.push([t, x, y]); while (bursts.length && t - bursts[0][0] > 700) bursts.shift();
    var near = 0; for (var i = 0; i < bursts.length; i++) if (Math.abs(bursts[i][1] - x) <= 30 && Math.abs(bursts[i][2] - y) <= 30) near++;
    if (near >= 3) {
      c.rage = 1; if (!(lastClick && lastClick.rage && t - lastClick.t <= 700)) c.rb = 1;
      for (var p = 0; p < pending.length; p++) { var o = pending[p]; if (t - o.t <= 700 && Math.abs(o.x - x) <= 30 && Math.abs(o.y - y) <= 30) o.rage = 1; } // the earlier taps of the burst, still waiting for their verdict
    }
    lastClick = c;
    pending.push(c); watch();
    (function (cc) { setTimeout(function () { settle(cc, 'timeout'); }, 900); })(c);
  }, true);

  /* ---- scrolling, the mouse, errors, fields, visibility ---- */
  var sLast = 0, sTimer = null;
  var sample_s = function () { var y = Math.round(window.scrollY || 0); sdist += Math.abs(y - lastY); lastY = y; depth(); push({ k: 's', t: now(), y: y, ph: pageH() }); schedule(); };
  document.addEventListener('scroll', function () { var t = now(); if (t - sLast >= 400) { sLast = t; sample_s(); } else if (!sTimer) { sTimer = setTimeout(function () { sTimer = null; sLast = now(); sample_s(); }, 400 - (t - sLast)); } }, { passive: true, capture: true });
  if (MOVES && !touch) {
    var mLast = 0, mx = -1, my = -1;
    document.addEventListener('mousemove', function (e) {
      var t = now(); if (t - mLast < 150 || moveN >= MOVE_MAX) return;
      var x = Math.round(e.pageX), y = Math.round(e.pageY); if (Math.abs(x - mx) < 4 && Math.abs(y - my) < 4) return;
      mLast = t; mx = x; my = y; moveN++; moves.push([t, x, y]); if (moves.length >= 40) { ev.push({ k: 'm', pts: moves }); moves = []; } schedule();
    }, { passive: true });
  }
  window.addEventListener('error', function (e) {
    if (!e || !e.message) return;                                                         // a resource that failed to load is not a script error
    if (errN++ >= 5) return;
    var src = ''; try { src = String(e.filename || '').replace(/^https?:\/\/[^/]+/, '').split('?')[0].slice(0, 120); } catch (x) {}
    push({ k: 'e', t: now(), msg: String(e.message).slice(0, 160), src: src, line: e.lineno || 0, col: e.colno || 0 });
    if (lastClick && now() - lastClick.t <= 1000) lastClick.err = 1;
    schedule();
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    if (errN++ >= 5) return; var r = e && e.reason; var msg = r && r.message ? r.message : String(r || 'promise');
    push({ k: 'e', t: now(), msg: ('Promise: ' + msg).slice(0, 160), src: '', line: 0, col: 0 }); schedule();
  });
  document.addEventListener('focusin', function (e) { var el = e.target; if (el && el.matches && el.matches('input:not([type=hidden]),textarea,select')) { push({ k: 'f', t: now(), sel: vlSel(el) }); schedule(); } }, true);
  document.addEventListener('visibilitychange', function () { push({ k: 'v', t: now(), s: document.visibilityState === 'visible' ? 1 : 0 }); if (document.visibilityState === 'hidden') flush(false); else schedule(); });
  var end = function () {
    if (gone) return; gone = true; if (timer) { clearTimeout(timer); timer = null; }
    depth(); push({ k: 'end', t: now(), dur: now(), maxd: r4(maxd), sdist: Math.round(sdist) }); flush(true);
  };
  window.addEventListener('pagehide', end);
  /* the view itself: sent soon after the page is up, so a visitor who never moves still counts */
  depth();
  var open = function () { setTimeout(function () { if (!opened && !gone) flush(false); }, 1200); };
  if (document.readyState === 'complete') open(); else window.addEventListener('load', open, { once: true });
})();
